import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BookOpen, Brain, BookHeart, Calendar, ShieldAlert, MessageCircle } from 'lucide-react';
const features = [{
  title: 'Layanan Edukasi',
  description: 'Akses berbagai artikel dan materi edukatif untuk pengembangan diri dan karier.',
  icon: BookOpen,
  link: '/edukasi',
  color: 'bg-pastel-blue-light',
  iconColor: 'text-blue-600'
}, {
  title: 'Asesmen Minat Bakat',
  description: 'Kenali potensi dirimu melalui tes minat bakat, tes emosi, dan mental health.',
  icon: Brain,
  link: '/asesmen',
  color: 'bg-pastel-pink-light',
  iconColor: 'text-pink-600'
}, {
  title: 'Jurnal Harian',
  description: 'Catat suasana hatimu hari ini dan ungkapkan apa yang sedang kamu rasakan.',
  icon: BookHeart,
  link: '/jurnal',
  color: 'bg-pastel-grey-light',
  iconColor: 'text-gray-700'
}, {
  title: 'Booking Layanan',
  description: 'Jadwalkan sesi bimbingan atau konseling dengan guru BK secara mudah.',
  icon: Calendar,
  link: '/bimbingan',
  color: 'bg-pastel-blue-light',
  iconColor: 'text-blue-600'
}, {
  title: 'Pelaporan Anonim',
  description: 'Laporkan kejadian atau masalah secara aman dengan identitas yang dirahasiakan.',
  icon: ShieldAlert,
  link: '/pelaporan',
  color: 'bg-pastel-pink-light',
  iconColor: 'text-pink-600'
}, {
  title: 'Curhat BK',
  description: 'Layanan chatbot interaktif untuk berbagi cerita dan keluh kesahmu.',
  icon: MessageCircle,
  link: 'https://links.collect.chat/69bdeb1f722745b5d3d226ac',
  isExternal: true,
  color: 'bg-pastel-grey-light',
  iconColor: 'text-gray-700'
}];
export function Home() {
  return <div className="min-h-screen bg-white" data-id="element-275">
      {/* HERO TEXT SECTION */}
      <section className="pt-10 md:pt-14 pb-10 text-center max-w-3xl mx-auto px-4" data-id="element-276">
        <span className="inline-block py-1 px-3 rounded-full bg-pink-100 text-pink-700 text-sm mb-6" data-id="element-277">
          Dikembangkan oleh: Meita Sulistiyo (2400751)
        </span>

        <h1 className="md:text-6xl font-bold mb-6 text-[#8D0D35] text-[45px] font-['Times_New_Roman',_serif]" data-id="element-278">
          DIGICOUNS
        </h1>

        <p className="font-['Times_New_Roman',_serif] text-[#400E21] text-[20px] bg-[#F8E8EE00]" data-id="element-279">
          Temukan versi terbaik dari dirimu mulai dari sini. Digicouns hadir
          sebagai Ruang Bimbingan dan Konseling digital aman yang dirancang
          untuk menemani setiap langkahmu.
        </p>
      </section>

      {/* ✅ BANNER DIPINDAH KE SINI (TIDAK KEPOTONG LAGI) */}
      <section className="w-full px-4 md:px-10 mb-16" data-id="element-280">
        <div className="max-w-7xl mx-auto rounded-2xl overflow-hidden shadow-lg" data-id="element-281">
          <img src="https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Digicouns.png" alt="banner" className="w-full h-auto object-contain" data-id="element-282" />
        </div>
      </section>

      {/* FEATURES */}
      <section className="py-16" data-id="element-283">
        <div className="max-w-7xl mx-auto px-4" data-id="element-284">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-285">
            {features.map((f, i) => {
            const Icon = f.icon;
            const Card = <div className="p-8 rounded-3xl border hover:shadow-lg transition bg-[#F8E8EE87]" data-id="element-286">
                  <div className={`w-12 h-12 rounded-xl ${f.color} flex items-center justify-center mb-5`} data-id="element-287">
                    <Icon className={`w-6 h-6 ${f.iconColor}`} data-id="element-288" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2" data-id="element-289">{f.title}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-290">{f.description}</p>
                </div>;
            return <div key={i} data-id="element-291">
                  {f.isExternal ? <a href={f.link} target="_blank" rel="noreferrer" data-id="element-292">
                      {Card}
                    </a> : <Link to={f.link} data-id="element-293">{Card}</Link>}
                </div>;
          })}
          </div>
        </div>
      </section>
    </div>;
}